//* 자주쓰는 상주말씀 프리셋 — 운영 DB 실측 상위 문구(서버 상수)
//* 스펙: docs/bugo-mourner-text-favorites-spec.md
//* GET public/fevent/mourner-text-presets → { featured: 5개(폼 바로 노출), more: 나머지(더보기) }
import { api_ } from '@shared/plugIn/axios';
import { useQuery } from 'react-query';

export interface MournerTextPreset {
  //* 안정 식별자(문구가 다듬어져도 유지)
  key: string;
  text: string;
  //* 실측 사용 건수(참고용)
  count: number;
}

export interface MournerTextPresets {
  featured: MournerTextPreset[];
  more: MournerTextPreset[];
}

export const EMPTY_MOURNER_TEXT_PRESETS: MournerTextPresets = { featured: [], more: [] };

const asPresetList = (value: unknown): MournerTextPreset[] =>
  Array.isArray(value)
    ? value.filter(
        (p): p is MournerTextPreset =>
          !!p &&
          typeof p === 'object' &&
          typeof (p as MournerTextPreset).text === 'string',
      )
    : [];

export const getMournerTextPresets = async (): Promise<MournerTextPresets> => {
  try {
    const { data } = await api_.get<Partial<MournerTextPresets>>(
      'public/fevent/mourner-text-presets',
    );
    return { featured: asPresetList(data?.featured), more: asPresetList(data?.more) };
  } catch (e) {
    //* 구서버(404)·네트워크 오류면 프리셋 없이 동작한다 — 직접 입력·내 즐겨찾기는 그대로
    // eslint-disable-next-line no-console
    console.warn('[mournerTextPreset] 프리셋 조회 실패 — 프리셋 없이 진행', e);
    return EMPTY_MOURNER_TEXT_PRESETS;
  }
};

export const MOURNER_TEXT_PRESETS_QUERY_KEY = [
  'public',
  'fevent',
  'mourner-text-presets',
];

//* 서버 상수라 세션 동안 1회만 받는다 (창 포커스 refetch 없음)
export const useMournerTextPresets = () =>
  useQuery<MournerTextPresets>(MOURNER_TEXT_PRESETS_QUERY_KEY, getMournerTextPresets, {
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 0,
  });
